"use strict";
import {
  V3_CORE_FACTORY_ADDRESSES as UNISWAP_V3_FACTORY_ADDRESSES,
  NONFUNGIBLE_POSITION_MANAGER_ADDRESSES as UNISWAP_NFT_MANAGER_ADDRESSES,
  QUOTER_ADDRESSES as UNISWAP_QUOTER_ADDRESSES,
  SWAP_ROUTER_02_ADDRESSES as UNISWAP_SWAP_ROUTER_ADDRESSES,
  V2_FACTORY_ADDRESSES as UNISWAP_V2_FACTORY_ADDRESSES,
  V2_ROUTER_ADDRESSES as UNISWAP_V2_ROUTER_ADDRESSES,
  MULTICALL_ADDRESSES as UNISWAP_MULTICALL_ADDRESSES
} from "@uniswap/sdk-core";
import { UniverseChainId } from "features/chains/types";
import { getBscContracts, MULTICALL3_ADDRESS } from "constants/bscContracts";
export { MULTICALL3_ADDRESS } from "constants/bscContracts";
export const V3_CORE_FACTORY_ADDRESSES = {
  ...UNISWAP_V3_FACTORY_ADDRESSES,
  [UniverseChainId.Sepolia]: getBscContracts(UniverseChainId.Sepolia)?.clFactory ?? UNISWAP_V3_FACTORY_ADDRESSES[UniverseChainId.Sepolia],
  [UniverseChainId.Mainnet]: getBscContracts(UniverseChainId.Mainnet)?.clFactory ?? UNISWAP_V3_FACTORY_ADDRESSES[UniverseChainId.Mainnet]
};
export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = {
  ...UNISWAP_NFT_MANAGER_ADDRESSES,
  [UniverseChainId.Sepolia]: getBscContracts(UniverseChainId.Sepolia)?.nonfungiblePositionManager ?? "",
  [UniverseChainId.Mainnet]: getBscContracts(UniverseChainId.Mainnet)?.nonfungiblePositionManager ?? ""
};
export const QUOTER_ADDRESSES = {
  ...UNISWAP_QUOTER_ADDRESSES,
  [UniverseChainId.Sepolia]: getBscContracts(UniverseChainId.Sepolia)?.quoterV2 ?? "",
  [UniverseChainId.Mainnet]: getBscContracts(UniverseChainId.Mainnet)?.quoterV2 ?? ""
};
export const SWAP_ROUTER_ADDRESSES = {
  ...UNISWAP_SWAP_ROUTER_ADDRESSES,
  [UniverseChainId.Sepolia]: getBscContracts(UniverseChainId.Sepolia)?.swapRouter ?? "",
  [UniverseChainId.Mainnet]: getBscContracts(UniverseChainId.Mainnet)?.swapRouter ?? ""
};
export const V2_FACTORY_ADDRESSES = {
  ...UNISWAP_V2_FACTORY_ADDRESSES,
  [UniverseChainId.Sepolia]: getBscContracts(UniverseChainId.Sepolia)?.poolFactory ?? "",
  [UniverseChainId.Mainnet]: getBscContracts(UniverseChainId.Mainnet)?.poolFactory ?? ""
};
export const V2_ROUTER_ADDRESSES = {
  ...UNISWAP_V2_ROUTER_ADDRESSES,
  [UniverseChainId.Sepolia]: getBscContracts(UniverseChainId.Sepolia)?.router ?? "",
  [UniverseChainId.Mainnet]: getBscContracts(UniverseChainId.Mainnet)?.router ?? ""
};
export const MULTICALL_ADDRESSES = {
  ...UNISWAP_MULTICALL_ADDRESSES,
  [UniverseChainId.Sepolia]: MULTICALL3_ADDRESS,
  [UniverseChainId.Mainnet]: MULTICALL3_ADDRESS
};
export {
  V2_ROUTER_ADDRESS,
  WETH9
} from "@uniswap/sdk-core";
